import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center h-[60vh] md:h-[70vh] text-center px-4">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-gray-50 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-gold-50 text-gold-600 mx-auto mb-4">
          <i className="ri-error-warning-line text-3xl" />
        </div>
        <h1 className="font-heading text-2xl md:text-3xl font-bold text-primary-900 mt-2">
          Page Not Found
        </h1>
        <p className="mt-2 text-sm text-gray-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-base text-gray-500 max-w-md">
          The page you are looking for does not exist or has been moved.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 mt-6 px-6 py-3 bg-gold-600 hover:bg-gold-700 text-white font-medium rounded-lg transition-colors text-sm whitespace-nowrap"
        >
          <i className="ri-home-line" />
          Go to Homepage
        </Link>
      </div>
    </div>
  );
}